// VelocidadeConexaoContext.jsx
import React, { createContext, useContext, useCallback, useMemo, useState } from "react";

const VelocidadeConexaoContext = createContext(null);

const DEFAULT_VALUE = {
  status: "unknown",   // unknown | checking | good | warn | bad
  pingMs: null,
  mbps: null,
  lastUpdated: null,
  source: "init",
};

export function VelocidadeConexaoProvider({ children, storageKey = "velocidade-conexao" }) {
  const [state, setState] = useState(() => {
    try {
      const cached = sessionStorage.getItem(storageKey);
      return cached ? JSON.parse(cached) : DEFAULT_VALUE;
    } catch { return DEFAULT_VALUE; }
  });

  const save = useCallback((updater) => {
    setState(prev => {
      const next = typeof updater === "function" ? updater(prev) : updater;
      try { sessionStorage.setItem(storageKey, JSON.stringify(next)); } catch {}
      return next;
    });
  }, [storageKey]);

  const setConnectionInfo = useCallback((info) => {
    save(prev => ({ ...prev, ...info, lastUpdated: Date.now() }));
  }, [save]);

  const updateConnectionInfo = useCallback((partial) => {
    save(prev => ({ ...prev, ...partial, lastUpdated: Date.now() }));
  }, [save]);

  const value = useMemo(() => ({
    ...state,
    setConnectionInfo,
    updateConnectionInfo,
  }), [state, setConnectionInfo, updateConnectionInfo]);

  return (
    <VelocidadeConexaoContext.Provider value={value}>
      {children}
    </VelocidadeConexaoContext.Provider>
  );
}

export function useVelocidadeConexao() {
  const ctx = useContext(VelocidadeConexaoContext);
  if (!ctx) throw new Error("useVelocidadeConexao deve ser usado dentro do VelocidadeConexaoProvider");
  return ctx;
}
